import { render, staticRenderFns } from "./ReportTaxInvoice.vue?vue&type=template&id=1d2a0ab8&"
import script from "./ReportTaxInvoice.vue?vue&type=script&lang=ts&"
export * from "./ReportTaxInvoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d2a0ab8')) {
      api.createRecord('1d2a0ab8', component.options)
    } else {
      api.reload('1d2a0ab8', component.options)
    }
    module.hot.accept("./ReportTaxInvoice.vue?vue&type=template&id=1d2a0ab8&", function () {
      api.rerender('1d2a0ab8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-receivables/reports/ReportTaxInvoice.vue"
export default component.exports